import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Brand, Color } from '../../../lib/theme';

import noticeStyles from './Notice_styles';

export interface NoticeProps {
  className?: string;
  brand?: Brand;
  color?: Color;
  align?: 'left' | 'center' | 'right' | 'justify';
  children: React.ReactNode;
}

const Notice = ({
  className,
  children,
  styles,
}: NoticeProps & StylesProps<typeof noticeStyles>) => (
  <div className={cx(styles.container, className)}>{children}</div>
);

export default styled(noticeStyles)(Notice);
